import { useTranslation } from "react-i18next";
import { FleetioLogo } from "~/components/fleet-dark/FleetDarkLogos";

export function FleetioHero() {
  const { t } = useTranslation("fleetio");

  return (
    <section className="wrap mt-20 flex flex-col items-center gap-20 lg:mt-0 lg:flex-row lg:justify-center lg:gap-[7.5rem] lg:py-20 xl:gap-20 xl:py-28">
      <FleetioLogo color="black" width={288} className="shrink-0" />
      <div className="flex min-w-0 flex-col items-center lg:items-start">
        <p className="mb-1 text-base font-bold text-[#595D65] uppercase lg:text-xl">{t("hero.eyebrow")}</p>
        <h1 className="font-display mb-12 max-w-[200px] text-center text-[32px] leading-[1.1] font-extrabold text-[#1E1F22] sm:max-w-none sm:text-[40px] lg:m-0 lg:text-left">
          {t("hero.title")}
        </h1>
      </div>
    </section>
  );
}

export default FleetioHero;
